import React, { Component } from 'react';
import './SearchBar.css';
import { DebounceInput } from 'react-debounce-input';
import classNames from 'classnames';
import SvgAF from 'components/shared/SvgAF/SvgAF';
import { IconLoader } from 'common/IconLoader';

//TODO: implement search icon hovering? Should probably hover over whole bar, not just icon itself
//import IconLoader.icon_search_hover from "imgs/icons/windows/IconLoader.icon_search_hover.svg";

class SearchBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      touched: false,
      focused: false,
      animateError: 0,
      value: ''
    };
  }

  componentDidMount() {
    if (this.props.startingValue) {
      this.setState({
        value: this.props.startingValue,
        touched: true
      });
    } else {
      this.setState({
        touched: false
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.startingValue !== this.props.startingValue) {
      if (this.props.startingValue) {
        this.setState({
          value: this.props.startingValue,
          touched: true
        });
      } else {
        this.setState({
          value: '',
          touched: false
        });
      }
    }
  }

  render() {
    let dropdown = null;
    if (this.props.dropdown && this.state.focused) {
      dropdown = this.props.dropdown;
    }
    //console.log("animateError:", this.state.animateError);
    return (
      <div className={classNames({ SearchBar_OuterDiv: true, searchError: this.state.animateError > 0 })}>
        <div className={'searchContainer iconClassName'}>
          <div className={'searchIcon'}>
            <SvgAF img={this.props.customIcon ? this.props.customIcon : IconLoader.icon_search_blue} />
          </div>
          <DebounceInput
            placeholder={this.props.defaultText}
            style={{ color: this.state.touched ? '#1D3648' : '#1D3648' }}
            className={classNames({ SearchBar_Input: true })}
            debounceTimeout={this.props.id === 'devicesView' ? 2000 : 200}
            value={this.state.value}
            autoFocus={this.props.autoFocus ? true : false}
            onFocus={(e) => {
              if (!this.state.touched) {
                this.setState({ touched: true, value: '', focused: true });
              } else {
                this.setState({ touched: true, focused: true });
              }
            }}
            onBlur={(e) => {
              if (this.props.handleBlur) {
                this.props.handleBlur();
              }
              if (e.target.value === '') {
                this.setState({
                  focused: false,
                  touched: false,
                  value: ''
                });
              } else {
                this.setState({ focused: false });
              }
            }}
            onChange={(e) => {
              const value = e.target.value;
              this.setState({ value });
              this.props.searchQuery(value.trim());
            }}
            onKeyPress={(event) => {
              if (event.key === 'Enter') {
                if (this.props.handleEnter == null) {
                  /* Default enter behavior */
                  event.target.blur();
                  this.props.searchQuery('');
                  return;
                }

                /* Default behavior overwritten in custom handleEnter function */
                this.props.handleEnter(event, this);
              }
            }}
            onKeyDown={(event) => {
              if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                if (this.props.handleArrow == null) {
                  return;
                }
                this.props.handleArrow(event.key, this);
              }
            }}
          />
          {this.props.onClose && this.state.value !== '' && (
            <button
              className={'SearchBar_CloseX'}
              onClick={() => {
                this.setState({ value: '' });
                this.props.searchQuery('');
              }}
            >
              <SvgAF img={IconLoader.icon_close_x} hover={IconLoader.icon_close_x_hover} />
            </button>
          )}
        </div>
        {dropdown != null ? <div className={'SearchBar_Dropdown_Div Global_Modal_Shadow'}>{dropdown}</div> : null}
      </div>
    );
  }
}

export default SearchBar;
